// Data file for Formula component
// Contains image URLs separated by device type (desktop/mobile)

export const DESKTOP_FORMULA_IMAGES = [
  "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/desktop/page9/Asset035.png"
];

export const MOBILE_FORMULA_IMAGES = [
  "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page9/Asset050.png",
  "https://gpfimg-cdn.azureedge.net/micrositemygpftwins/phase3/mobile/page9/Asset051.png"
];

// Legacy export for backward compatibility
export const FORMULA_IMAGES = {
  desktop: DESKTOP_FORMULA_IMAGES,
  mobile: MOBILE_FORMULA_IMAGES
};

